module.exports = __webpack_public_path__ + "img/error-x.5cf7b288.png";